import React from 'react'
import PropTypes from 'prop-types'

import './SingleArticleQuote.css'

const SingleArticleQuote = ({ antrfile }) => (
    <section className="single-article-quote">
        <blockquote dangerouslySetInnerHTML={antrfile} />
    </section>
)

SingleArticleQuote.propTypes = {
    antrfile: PropTypes.shape({ __html: PropTypes.string.isRequired })
}

export { SingleArticleQuote }
